export const INVENTORY_GET_ROLE = "pyctor.registry.inventory.get";
export const INVENTORY_POST_ROLE = "pyctor.registry.inventory.post";
export const TRADER_ACCESS_ROLE = "zero13.trader.access.role";
export const TRANSACTIONS_ACCESS_ROLE = "zero13.transactions.role";
